import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	moveToTop: {
		id: 'eoc-schedule.ui.list.list-item.move-to-top',
		defaultMessage: 'Move to top',
		description: 'Label of a button for moving an item to the top of the list',
	},
	moveToBottom: {
		id: 'eoc-schedule.ui.list.list-item.move-to-bottom',
		defaultMessage: 'Move to bottom',
		description: 'Label of a button for moving an item to the bottom of the list',
	},
	moveUp: {
		id: 'eoc-schedule.ui.list.list-item.move-up',
		defaultMessage: 'Move up',
		description: 'Label of a button for moving an item up in the list',
	},
	moveDown: {
		id: 'eoc-schedule.ui.list.list-item.move-down',
		defaultMessage: 'Move down',
		description: 'Label of a button for moving an item down in the list',
	},
	reorder: {
		id: 'eoc-schedule.ui.list.list-item.reorder',
		defaultMessage: 'Reorder {title} at position {position}',
		description: 'Label of a button for reordering an item in the list',
	},
});
